<script>

import VAutocomplete from 'vuetify/lib/components/VAutocomplete/VAutocomplete';

export default {
  extends: VAutocomplete,
  props: {
      autoSelectIndex: {
      type: Number,
      default: null,
    },
    alwaysShowValue: {
      type: String,
      default: null
    },
    filter: {
      type: Function,
      default: function (item, queryText, itemText) {
        return (this.alwaysShowValue !== null && item[this.itemValue] === this.alwaysShowValue) ||
          itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
      }
    },
  },
  computed:{
     filteredItems (){
      //overwriting computed property of vuetify 2.x VAutocomplete 
      if (!this.isSearching || this.noFilter || this.internalSearch == null) return this.allItems;
      const alphasorted =  this.allItems.filter(item => this.filter(item, String(this.internalSearch), String(this.getText(item))));
      //we can be lazy(fast) on sorting because alphasorted is supposed to be sorted
      return alphasorted.sort((a, b) => (a.name.toLowerCase().startsWith(this.internalSearch.toLowerCase()) 
                                      && !b.name.toLowerCase().startsWith(this.internalSearch.toLowerCase())) 
                                      ? -1 
                                      : 1);
    },
  },
  watch: {
    filteredItems: 'onFilteredItemsChanged'
  },
  methods: {
     onKeyDown (e) {
      const keyCode = e.keyCode;
      if( keyCode === 13 &&
          this.allItems.includes(this.selectedItem) &&
          this.selectedItem.name === this.internalSearch &&
          !this.isMenuActive) {
            //deaktiviert Enter Taste bei geschlossenem Dropdown alternativ müsste onFilteredItemsChanged diesen Fall erkennen 
      } else {
        VAutocomplete.options.methods.onKeyDown.call(this, e);
      }

      // The ordering is important here
      // allows new value to be updated
      // and then moves the index to the
      // proper location
      //this.changeSelectedIndex(keyCode)
    },
    onInput (e) {
      //overwriting method of vuetify 2.x VAutocomplete
      if (
        this.selectedIndex > -1 ||
        !e.target
      ) return;

      const target = e.target; //as HTMLInputElement
      const value = target.value;
      const letter = e.data;

      // If typing and menu is not currently active
      if (target.value) this.activateMenu();

      //the overwrite: if user is editing a already selected list item, start an new search instead 
      if (value && this.selectedItems[0] && value != this.selectedItems[0].name){
        console.log( this.selectedIndex, this.selectedItems, this.value);
        this.internalSearch = letter;
        this.selectedItems = [];
      } else {
        this.internalSearch = value;
      }

      this.badInput = target.validity && target.validity.badInput;
    },
    onFilteredItemsChanged (val, oldVal) {
      if (val === oldVal) return;

      //Bug? resetting the index must not happen on enter press of valid entry
      this.setMenuIndex(-1);

      this.$nextTick(() => {
        if (
          !this.internalSearch ||
          (val.length !== 1 &&
            !this.autoSelectFirst &&
            isNaN(this.autoSelectIndex))
        ) return;

        this.$refs.menu.getTiles();
        const currentAutoSelectFix = ( this.autoSelectIndex && this.filteredItems && this.filteredItems[0] && !this.filteredItems[0].name.startsWith('--') ) ? -1 : 0;
         //Bug? resetting the index must not happen on enter press of valid entry
        this.setMenuIndex(isNaN(this.autoSelectIndex) || (this.filteredItems.length - 1) < this.autoSelectIndex ? 0 : this.autoSelectIndex + currentAutoSelectFix);
      });
    }
  }

};

</script>
